import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import { Link, ResponsiveHeroImage, ReviewRating } from "@quintype/components";
import { ImageFallback } from "./image-fallback.js";
import get from "lodash/get";
import { breakpoint } from "../../../utils/breakpoint";
import { altTagOfHeroImages, isExternalStory, getCarousel } from "../../utils";

function SimpleSlider(props) {
  const settings = {
    dots: false,
    infinite: props.stories.length > 1,
    speed: 600,
    arrows: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    rtl: get(props.config, ["theme-attributes", "language_direction"]) === "right"
  };

  const SliderWrapper = (
    <Slider {...settings}>
      {props.stories.map(item => (
        <div key={item.id}>
          <SliderItem item={item} heading={props.heading} />
        </div>
      ))}
    </Slider>
  );

  const Slide = <SliderItem item={props.stories[0]} heading={props.heading} />;

  return !props.stories.length ? null : <div className="simple-slider">{getCarousel(SliderWrapper, Slide)}</div>;
}

SimpleSlider.propTypes = {
  config: PropTypes.object,
  stories: PropTypes.array,
  heading: PropTypes.string
};

function SliderItem(props) {
  /* The `story` can be an item from items of a collection or a story itself.
    assigning it accordinlgy. */
  const story = props.item && props.item.type === "story" && props.item.story ? props.item.story : props.item;
  const isReviewStory = story["story-template"] === "review";
  const aspectRatio = breakpoint("tablet") ? [4, 3] : [9, 3];

  return (
    <div className="simple-slider__item">
      {story["hero-image-s3-key"] ? (
        <figure className={`${story["story-template"] === "video" ? "simple-slider__image__video" : ""}`}>
          <ResponsiveHeroImage
            story={story}
            aspectRatio={aspectRatio}
            alt={altTagOfHeroImages(story)}
            defaultWidth={480}
            widths={[250, 480, 640]}
            sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 23%"
            imgParams={{ auto: ["format", "compress"], fit: "max" }}
          />
        </figure>
      ) : (
        <ImageFallback bgColor="#adc1d6" />
      )}
      <div className="simple-slider__content">
        <p className="simple-slider__section-name" data-test-id="simple-slider-section-name">
          {props.heading}
        </p>
        <h2 className="simple-slider__story-heading" data-test-id="simple-slider-headling">
          <bdi dangerouslySetInnerHTML={{ __html: story.headline }} />
        </h2>
        {isReviewStory && <ReviewRating value={get(story, ["metadata", "review-rating", "value"], "0")} />}
        <Link
          href={"/" + story.slug}
          externalLink={isExternalStory(story)}
          className="simple-slider__link"
          data-test-id="simple-slider-readmore-link"
        >
          read story
        </Link>
      </div>
    </div>
  );
}

SliderItem.propTypes = {
  item: PropTypes.object,
  heading: PropTypes.string
};

export { SimpleSlider };
